import BetKeypad from "./BetKeypad";
import DrawTimer from "./DrawTimer";
import KeypadHeader from "./KeypadHeader";
import PrizeBanners from "./PrizeBanners";
import QuickActions from "./QuickActions";


export default function Keypad() {
  return (
    <div className="min-h-screen  relative overflow-hidden  bg-[#1e3a8a] p-4 font-poppins">
      <KeypadHeader balance={17248} cartCount={2} />
      <PrizeBanners />
      <DrawTimer drawTime="2PM" drawDate="Thu, 22-August-24" />
      <QuickActions />
      <BetKeypad
        onNumberPress={(num) => console.log("Number pressed:", num)}
        onDelete={() => console.log("Delete pressed")}
        onAddBets={() => console.log("Add bets pressed")}
      />
    </div>
  );
}
